import React, { useEffect, useState } from 'react'
import { BreadCrumbSecttion } from '../component/BreadCrumbSecttion'
import { Col, Container, Row } from 'react-bootstrap'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Loader from '../component/Loader'
import RegistrationService from '../services/registration';
import PrimaryGradientButton from '../component/PrimaryGradientButton';
import OtherService from '../services/Other';
import delivery from '../assets/images/delivery.png';
import { Home } from 'react-feather';
import useScrollToTop from '../hooks/useScrollToTop';
import PrimaryOutLineButton from '../component/PrimaryOutLineButton';
const Delivery = () => {
    useScrollToTop()
    // const location = useLocation();
    // const selectedAddress = location.state.selectedAddress;

    const [isAddressId, setIsAddressId] = useState()
    const [isAddress, setIsAddress] = useState({
        line1: '',
        line2: '',
        line3: '',
        post_code: ''
    })
    const { addressId } = useParams();
    
    const [isUser, setIsUser] = useState({ full_name: '', phone: '' })
    const [loading, setLoading] = useState(true);
    const currentDate = new Date();
    const tenDaysLater = new Date(currentDate);
    // 9 as told by testers
    tenDaysLater.setDate(tenDaysLater.getDate() + 9);
    const [hasAddress, setHasAddress] = useState(true)
    const [deliveryDate, setDeliveryDate] = useState(null);
    const [addressData, setAddressData] = useState({ line1: '', line2: '', line3: '', city: '', post_code: '' })
    const [borderActive, setBorderActive] = useState(true)

    const changeBgColor = () => {
        
        if(window.scrollY < 70) {
            setBorderActive(true)
        } else {
            setBorderActive(false)
        }
    }

    window.addEventListener('scroll', changeBgColor)

    useEffect(() => {
        const AddressFetchData = async () => {
            try {
                const token = localStorage.getItem('access_token');
                const AddressFetchResponse = await OtherService.addressListById(addressId)
                if (JSON.stringify(AddressFetchResponse) != '{}' && AddressFetchResponse.data.status === true && JSON.stringify(AddressFetchResponse.data.addressDetails) != '{}') {
                    setIsAddress(AddressFetchResponse.data.addressDetails)
                    setIsAddressId(AddressFetchResponse.data.addressDetails.id)
                    setHasAddress(true)

                    setLoading(false)
                }
                else {
                    setIsAddress(AddressFetchResponse.data.message)
                    setHasAddress(false)
                }
            }
            catch (error) {
                console.error("Address Fetch")
            }

        }
        AddressFetchData()

    }, [])
    useEffect(() => {
        const UserNameFetchData = async () => {
            try {
                const token = localStorage.getItem('access_token');
                const UserNameFetchResponse = await RegistrationService.getBasicProfileInfo(token);
                if (UserNameFetchResponse.success == true) {
                    setIsUser(UserNameFetchResponse.response.basicProfileDetails)
                    console.log("day------>", new Date(tenDaysLater));
                    
                    setDeliveryDate(new Date(tenDaysLater));
                    setLoading(false)
                }

            }
            catch (error) {
                console.error("User Name Fetch")

            }

        }
        UserNameFetchData()
    }, [])

    const navigate = useNavigate()
    const handleProceed = (addressId) => {
        
        navigate(`/delivery/${addressId}/place-order`)
    }
    return (
        <>
            {loading && <Loader />}
            <BreadCrumbSecttion
                pageTitle="Delivery"
                currentPageName="Delivery" />
            <section className='padTop50'>
                <Container>
                    <Row className=''>
                        <Col xs={12} md={4} className='deladdressBlock p-1'>
                            <div className='addressBlock selected del-addressBlock order-sm-1' >
                                <h4 className="section-title bborder-top">
                                    <span className="rgb-label grey-theme-background">
                                        <Home />
                                    </span>
                                    Delivery Address
                                </h4>

                                <div className='addressBlockWrap'>
                                    <div className='addressBlockArea'>
                                        <div className='addressTxtWrap'><div className='firstBlock'>Name</div><div className='secondBlock'>{isUser?.full_name}</div></div>
                                        {isAddress?.city && isAddress.city.trim() !== '' &&
                                        <div className='addressTxtWrap'><div className='firstBlock'>Address</div><div className='secondBlock'>{isAddress?.line1},{isAddress?.line2},{isAddress?.line3}</div></div>}
                                        {/* <div className='addressTxtWrap'><div className='firstBlock'>City </div><div className='secondBlock'>{isAddress?.city}</div></div> */}
                                        <div className='addressTxtWrap'><div className='firstBlock'>PostCode </div><div className='secondBlock'>{isAddress?.post_code}</div></div>
                                        <div className='addressTxtWrap'><div className='firstBlock'>Phone No</div><div className='secondBlock'>{isUser?.phone}</div></div>
                                        <div className='addressTxtWrap'><div className='firstBlock'>Delivery By</div><div className='secondBlock'>{deliveryDate? deliveryDate.toLocaleDateString('en-GB', {
                                            day: '2-digit',
                                            month: 'long',
                                            // year: 'numeric'
                                            })
                                            : "Not specified"
                                            }
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>

                        <Col xs={12} md={8} className='deliveryImageBlock order-sm-2'>

                            <div className='deliveryImage'>
                                <img src={delivery} alt='deliveryImage' className='img-fluid'/>
                            </div>
                        </Col>

                    </Row>
                   
                </Container>
                <Row className={`buttonWrapBottom transition-2 sticky-bottom ${borderActive? 'border-active':''}`}>
                        <Col xs={12} md ={6} lg={3}>
                            <PrimaryOutLineButton outlinebuttonText="Back" onClick={() => { navigate(-1) }}
                            />
                        </Col>
               
                        <Col xs={12} md ={6} lg={3}> 
                            <PrimaryGradientButton buttonText="Proceed" onClick={() => { handleProceed(isAddressId) }}
                        />
                            </Col>
                    </Row>
            </section>
        </>
    )
}

export default Delivery